export const deviceStatusOptions = [
    { value: 'Waiting for Approval', label: 'Waiting for Approval' },
    { value: 'Approved - Schedule Inspection', label: 'Approved - Schedule Inspection' },
    { value: 'Scheduled - Perform Test', label: 'Scheduled - Perform Test' },
    { value: 'Performed - Enter Results', label: 'Performed - Enter Results' },
    { value: 'Results Entered - Out for Survey', label: 'Results Entered - Out for Survey' },
    { value: 'Proposal Sent - Waiting for Approval', label: 'Proposal Sent - Waiting for Approval' },
    { value: 'Job Approved - Route Mechanic', label: 'Job Approved - Route Mechanic' },
    { value: 'Job Approved - Schedule Work', label: 'Job Approved - Schedule Work' },
    { value: 'Work Completed - Progress AOC', label: 'Work Completed - Progress AOC' },
    { value: 'Work Completed - Building Items Open', label: 'Work Completed - Building Items Open' },
    { value: 'Work Pending - AOC Created', label: 'Work Pending - AOC Created' },
    { value: 'AOC Created', label: 'AOC Created' },
    { value: 'Work Pending - AOC Accepted DOB Now', label: 'Work Pending - AOC Accepted DOB Now' },
    { value: 'Corrected - Verified on DOB Website', label: 'Corrected - Verified on DOB Website' },
    { value: 'Unsatisfactory', label: 'Unsatisfactory' },
    { value: 'AOC Rejected - Sent to Customer', label: 'AOC Rejected - Sent to Customer' },
    { value: 'Device Removed', label: 'Device Removed' },
    { value: 'Cancelled Contract', label: 'Cancelled Contract' },
    { value: 'Work Completed', label: 'Work Completed' },
    { value: 'Modernization', label: 'Modernization' },
    { value: 'Priced Out - Create Proposal', label: 'Priced Out - Create Proposal' },
    { value: 'Satisfactory', label: 'Satisfactory' },
    { value: 'AOC Sent to Customer', label: 'AOC Sent to Customer' },
    { value: 'Rejected Performed', label: 'Rejected Performed' },
    { value: 'Rejection Sent to Customer', label: 'Rejection Sent to Customer' },
    { value: 'AOC Submitted from DOB', label: 'AOC Submitted from DOB' },
    { value: 'Work in Progress', label: 'Work in Progress' },
    { value: 'New Construction', label: 'New Construction' },
    { value: 'Test Not Approved', label: 'Test Not Approved' },
    { value: 'Unsatisfactory - Non DOB', label: 'Unsatisfactory - Non DOB' },
    { value: 'AOC Done by Others', label: 'AOC Done by Others' },
    { value: 'AOC in Process', label: 'AOC in Process' },
    { value: 'Test Not Showing Up', label: 'Test Not Showing Up' },
    { value: 'Test Approved - No Witness Company Given', label: 'Test Approved - No Witness Company Given' },
    { value: 'Outerboro', label: 'Outerboro' },
    { value: 'Failed - Shut Down', label: 'Failed - Shut Down' },
    { value: 'Construction Use', label: 'Construction Use' },
    { value: 'DLM', label: 'DLM' },
    { value: 'Unsatisfactory - Too Late', label: 'Unsatisfactory - Too Late' },
    { value: 'Out of Service', label: 'Out of Service' },
    { value: 'Letter of Completion Sent to BD/Custom', label: 'Letter of Completion Sent to BD/Custom' },
    { value: 'Reinspection Requested', label: 'Reinspection Requested' },
    { value: 'DLM - Not Signed', label: 'DLM - Not Signed' },
    { value: 'DLM - Problems', label: 'DLM - Problems' },
    { value: 'Westchester', label: 'Westchester' },
    { value: 'Yonkers', label: 'Yonkers' },
    { value: 'New Rochelle', label: 'New Rochelle' },
    { value: 'Connecticut', label: 'Connecticut' },
    { value: 'New Jersey', label: 'New Jersey' },
    { value: 'Fire Service', label: 'Fire Service' },
    { value: 'Hunter', label: 'Hunter' },
    { value: 'Long Island', label: 'Long Island' }
];

export const buildingTypeOptions = [
    { value: 'Commercial', label: 'Commercial' },
    { value: 'Company/Office', label: 'Company/Office' },
    { value: 'Garage', label: 'Garage' },
    { value: 'Government', label: 'Government' },
    { value: 'Hospital', label: 'Hospital' },
    { value: 'Nursing Home', label: 'Nursing Home' },
    { value: 'Other', label: 'Other' },
    { value: 'Parent Location', label: 'Parent Location' },
    { value: 'Religious Facility', label: 'Religious Facility' },
    { value: 'Residential', label: 'Residential' },
    { value: 'Restaurant', label: 'Restaurant' },
    { value: 'School', label: 'School' },
    { value: 'Ship', label: 'Ship' },
    { value: 'Transportation Facility', label: 'Transportation Facility' },
];

export const deviceClassOptions = [
    { value: 'Traction', label: 'Traction' },
    { value: 'Drum', label: 'Drum' },
    { value: 'Hydraulic', label: 'Hydraulic' },
    { value: 'Platform Lift', label: 'Platform Lift' },
    { value: 'Material Lift', label: 'Material Lift' },
    { value: 'Manlift', label: 'Manlift' },
    { value: 'Conveyor', label: 'Conveyor' },
    { value: 'Stairlift', label: 'Stairlift' },
    { value: 'Escalator', label: 'Escalator' },
    { value: 'Moving Walk', label: 'Moving Walk' },
    { value: 'Wheelchair Lift', label: 'Wheelchair Lift' }
];


export const deviceSubclassOptions = [
    { value: 'Boreholed', label: 'Boreholed' },
    { value: 'Holeless', label: 'Holeless' },
    { value: 'Roped', label: 'Roped' },
    { value: 'Water', label: 'Water' },
    { value: 'Private Residence', label: 'Private Residence' },
    { value: 'LULA', label: 'LULA' },
    { value: 'Dumbwaiter', label: 'Dumbwaiter' },

];

export const deviceUseOptions = [
    { value: 'Passenger', label: 'Passenger' },
    { value: 'Freight', label: 'Freight' },
    { value: 'Material Lift', label: 'Material Lift' },
    { value: 'Construction Use', label: 'Construction Use' },
    { value: 'Dumbwaiter', label: 'Dumbwaiter' },
    { value: 'LULA', label: 'LULA' },
    { value: 'Other', label: 'Other' },
    { value: 'Sidewalk', label: 'Sidewalk' },
    { value: 'Wheelchair Lift', label: 'Wheelchair Lift' },
    { value: 'Conveyor', label: 'Conveyor' },
    { value: 'Escalator', label: 'Escalator' },
];

export const dobTypeOptions = [
    { value: 'Conveyor', label: 'Conveyor' },
    { value: 'Dumbwaiter', label: 'Dumbwaiter' },
    { value: 'Escalator', label: 'Escalator' },
    { value: 'Freight', label: 'Freight' },
    { value: 'Manlift', label: 'Manlift' },
    { value: 'Material Lift', label: 'Material Lift' },
    { value: 'Other', label: 'Other' },
    { value: 'Passenger', label: 'Passenger' },
    { value: 'Personel Hoist', label: 'Personel Hoist' },
    { value: 'Private Res. Elevator', label: 'Private Res. Elevator' },
    { value: 'Sidewalk', label: 'Sidewalk' },
    { value: 'Wheelchair Lift', label: 'Wheelchair Lift' },

];

export const deviceGeneralInfo = [
    { key: 'deviceId', label: 'Device ID', type: 'number' },
    { key: 'deviceName', label: 'Device Name', type: 'text' },
    { key: 'deviceType', label: 'Device Type', type: 'text' },
    { key: 'deviceStatus', label: 'Device Status', type: 'select', options: deviceStatusOptions },
    { key: 'buildingType', label: 'Building Type', type: 'select', options: buildingTypeOptions },
    { key: 'block', label: 'Block', type: 'text' },
    { key: 'bin', label: 'BIN', type: 'text' },
    { key: 'deviceDomain', label: 'Device Domain', type: 'text' },
    { key: 'buildingId', label: 'Building', type: 'text' },
    { key: 'customerId', label: 'Customer', type: 'number' },
    { key: 'managementId', label: 'Management Company', type: 'number' },
    { key: 'deviceClass', label: 'Device Class', type: 'select', options: deviceClassOptions },
    { key: 'deviceSubclass', label: 'Sub Class', type: 'select', options: deviceSubclassOptions },
    { key: 'deviceUse', label: 'Device Use', type: 'select', options: deviceUseOptions },
    { key: 'deviceBank', label: 'Device Bank', type: 'text' },
    { key: 'isKeyDevice', label: 'Key Device', type: 'checkbox' },
    { key: 'dobType', label: 'DOB Type', type: 'select', options: dobTypeOptions },
    { key: 'siteNumber', label: 'Site Number', type: 'text' },
    { key: 'deviceGroup', label: 'Device Group', type: 'text' },
    { key: 'cabPhone', label: 'Cab Phone', type: 'text' },
    { key: 'handicapStatus', label: 'Handicap Status', type: 'text' },
];



export const deviceListFields = [
    { key: 'buildingSite', label: 'Building Site' },
    { key: 'deviceId', label: 'Device ID' },
    { key: 'carNotes', label: 'Car Notes' },
    // type
    { key: 'deviceType', label: 'Device Type' },
    // class
    { key: 'deviceClass', label: 'Device Class' },
    { key: 'deviceSubclass', label: 'Device Subclass', },
    { key: 'deviceUse', label: 'Device Use' },
    { key: 'customerId', label: 'Customer ID' },
    { key: 'capacity', label: 'Capacity' },

    { key: 'carSpeed', label: 'Car Speed' },
    { key: 'floorCount', label: 'Floor Count' },
    // travel
    { key: 'elevatorTravel', label: 'Elevator Travel' },



]

export const deviceContractInfo = [
    { key: 'contractNumber', label: 'Contract Number' },
    { key: 'coverageType', label: 'Coverage Type' },
    { key: 'coverageHours', label: 'Coverage Hours' },
    { key: 'lastDispatchDate', label: 'Last Dispatch Date' },
];

export const deviceOtherInfo = [
    { key: 'capacity', label: 'Capacity', type: 'text' },
    { key: 'passengerCount', label: 'Number of Passengers', type: 'number' },
    { key: 'carSpeed', label: 'Car Speed', type: 'text' },
    { key: 'floorCount', label: 'Number of Floors', type: 'number' },
    { key: 'landingCount', label: 'Number of Landings', type: 'number' },
    { key: 'floorsServed', label: 'Floors Served', type: 'number' },
    { key: 'elevatorTravel', label: 'Travel', type: 'text' },
    { key: 'lastModernized', label: 'Last Modernized', type: 'date' },
];

export const DeviceStatusOptions = [
    { value: 'Active', label: 'Active' },
    { value: 'Inactive', label: 'Inactive' },
];

export const DeviceTypes = [
    { value: 'Traction', label: 'Traction' },
    { value: 'Drum', label: 'Drum' },
    { value: 'Hydraulic', label: 'Hydraulic' },
    { value: 'Platform Lift', label: 'Platform Lift' },
    { value: 'Material Lift', label: 'Material Lift' },
    { value: 'Manlift', label: 'Manlift' },
    { value: 'Conveyor', label: 'Conveyor' },
    { value: 'Stairlift', label: 'Stairlift' },
    { value: 'Escalator', label: 'Escalator' },
    { value: 'Moving Walk', label: 'Moving Walk' },
    { value: 'Wheelchair Lift', label: 'Wheelchair Lift' },
];

export const deviceClassToSubclassMap = {
    "Traction": [ // Traction
        {value: 'Gearless', label: 'Gearless'},
        {value: 'Geared Overhead', label: 'Geared Overhead'},
        {value: 'Geared Basement', label: 'Geared Basement'},
        {value: 'Machine Room-less', label: 'Machine Room-less'},

    ],
    'Drum': [ // Drum
        {value:'Gearless', label:'Gearless'},
        {value:'Basement', label:'Basement'},
        {value:'Private Residence', label:'Private Residence'},
        {value:'LULA', label:'LULA'},
        {value:'Dumbwaiter', label:'Dumbwaiter'},
        {value:'Sidewalk', label:'Sidewalk'},
    ],
    'Hydraulic': [ // Hydraulic
        { value: 'Boreholed', label: 'Boreholed' },
        { value: 'Holeless', label: 'Holeless' },
        { value: 'Roped', label: 'Roped' },
        { value: 'Water', label: 'Water' },
        { value: 'Private Residence', label: 'Private Residence' },
        { value: 'LULA', label: 'LULA' },
        { value: 'Dumbwaiter', label: 'Dumbwaiter' },
    ],
    'Platform List': [ // Platform List
        {value:'Hydraulic', label:'Hydraulic'},
        {value:'Screwdrive', label:'Screwdrive'},


    ],
    'Material Lift': [ // Material Lift
  
        {value:'Hydraulic', label:'Hydraulic'},
        {value:'Screwdrive', label:'Screwdrive'},
        {value:'VRC', label:'VRC'},

    ],
    'Manlift': [ // Manlift 
        // No options
{ value: 'N/A', label: 'N/A' },
    ],
    'Conveyor': [ // Conveyor 
        // No options    
        { value: 'N/A', label: 'N/A' },
    ],
    'Stairlift': [ // Stairlift
        // No options
        { value: 'N/A', label: 'N/A' },
    ],
    'Escalator': [ // Escalator
        // No options
        { value: 'N/A', label: 'N/A' },
    ],
    'Moving Walk': [ // Moving Walk
        // No options
        { value: 'N/A', label: 'N/A' },
    ],
    'Wheelchair Lift': [ // Wheelchair Lift
        // No options
        { value: 'N/A', label: 'N/A' },
    ],
};

export const defaultDeviceForm = {
    deviceType: '',
    deviceStatus: '',
    deviceDomain: '',
    block: '',
    bin: '',
    address: '',
    building: '',
    borough: '',
    buildingId: null,
    buildingSite: '',
    customerId: null,
    managementId: null,
    buildingType: '',
    coverage: '',
    cat1Insp: '',
    cat5Insp: '',
    periodicInsp: '',
    siteNumber: null,
    deviceBank: '',
    deviceGroup: null,
    isKeyDevice: false,
    deviceName: '',
    deviceTypeDdl: null,
    machineType: null,
    deviceUse: '',
    dobType: null,
    capacity: '',
    passengerCount: null,
    carSpeed: '',
    elevatorTravel: '',
    landingCount: null,
    floorCount: null,
    floorsServed: null,
    machineRoomLocation: '',
    buildingPower: null,
    controllerOperation: null,
    carOperation: null,
    fireService: null,
    handicappedStatus: '',
    originalDate: null,
    manufacturer: '',
    lastModernized: null,
    freeMaintenanceEnd: null,
    cabConfigurationType: null,
    recordId: null,
    carNotes: '',
    deviceClass: '',
    currentSubclass: '',
    deviceSubclass: ''
};